// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Caml from "../../../../node_modules/rescript/lib/es6/caml.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Card$Showside from "./Card.bs.js";
import * as Facets$Showside from "../types/Facets.bs.js";
import * as UseApi$Showside from "../hook/UseApi.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as PLPMedia$Showside from "./PLPMedia.bs.js";
import * as SWRUtils$Showside from "../utils/SWRUtils.bs.js";
import * as BasicTypes$Showside from "../types/BasicTypes.bs.js";
import * as LCPContext$Showside from "../context/LCPContext.bs.js";
import * as LazyRender$Showside from "../utils/LazyRender.bs.js";
import * as Persistence$Showside from "../utils/Persistence.bs.js";
import * as ProductCard$Showside from "./ProductCard.bs.js";
import * as UseTracking$Showside from "../hook/UseTracking.bs.js";
import * as ListPageGrid$Showside from "./ListPageGrid.bs.js";
import * as ErrorReporter$Showside from "./ErrorReporter.bs.js";
import * as ListPageSlider$Showside from "./ListPageSlider.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as PlaceholderCard$Showside from "./PlaceholderCard.bs.js";
import * as RollbarInstance$Showside from "../utils/RollbarInstance.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as UseFirstAndLastCard$Showside from "../hook/UseFirstAndLastCard.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as GridDensityZoomProvider$Showside from "../context/GridDensityZoomProvider.bs.js";
import * as ListPageGridCustomSlots$Showside from "./ListPageGridCustomSlots.bs.js";
import * as InfiniteScrollProximitySensor$Showside from "../utils/InfiniteScrollProximitySensor.bs.js";
function usePersistentProducts(products, isFetching, reachedEnd) {
  var previousProducts = Persistence$Showside.use(products);
  var persistedProducts = isFetching ? previousProducts : products;
  var reachedEnd$1 = Belt_Option.isSome(previousProducts) && isFetching ? true : reachedEnd;
  return [persistedProducts, reachedEnd$1];
}
function usePagination(category, appliedFilters, sort, limitOpt, param) {
  var limit = limitOpt !== undefined ? limitOpt : 10;
  var match = EntrypointContext$Showside.use(undefined);
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var match$2 = match$1.config;
  var account = match$2.transitiveAccount;
  var connection = Category$Showside.ExternalConnection.getStoreCategoryConnection(category);
  var defaultFilters = Belt_Option.flatMap(Category$Showside.ExternalConnection.getStoreCategoryConnection(category), function (connection) {
    return Category$Showside.ExternalConnection.getFilterBy(connection, account);
  });
  return UseApi$Showside.useCategoryProducts(undefined, match$2.transitiveStoreId, category.id, connection, match$2.settings.hideOutOfStock, appliedFilters, defaultFilters, limit, sort, true, match.smartnavApiHost, undefined, match.market, undefined).swr;
}
function ProductsContent(Props) {
  var category = Props.category;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var layout = Props.layout;
  var shouldCenterSlidesOpt = Props.shouldCenterSlides;
  var isPaddingEnabledOpt = Props.isPaddingEnabled;
  var isZoomEnabledOpt = Props.isZoomEnabled;
  var enableSmartCardOpt = Props.enableSmartCard;
  var enableFirstCardOpt = Props.enableFirstCard;
  var enableLastCardOpt = Props.enableLastCard;
  var enableInlineMediaOpt = Props.enableInlineMedia;
  var priorityOpt = Props.priority;
  var forcedSize = Props.forcedSize;
  var forcedShape = Props.forcedShape;
  var forcedOpenLink = Props.forcedOpenLink;
  var shouldCenterSlides = shouldCenterSlidesOpt !== undefined ? shouldCenterSlidesOpt : false;
  var isPaddingEnabled = isPaddingEnabledOpt !== undefined ? isPaddingEnabledOpt : true;
  var isZoomEnabled = isZoomEnabledOpt !== undefined ? isZoomEnabledOpt : true;
  var enableSmartCard = enableSmartCardOpt !== undefined ? enableSmartCardOpt : false;
  var enableFirstCard = enableFirstCardOpt !== undefined ? enableFirstCardOpt : true;
  var enableLastCard = enableLastCardOpt !== undefined ? enableLastCardOpt : true;
  var enableInlineMedia = enableInlineMediaOpt !== undefined ? enableInlineMediaOpt : false;
  var priority = priorityOpt !== undefined ? priorityOpt : 0;
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config;
  var account = match$1.transitiveAccount;
  var settings = match$1.settings;
  var configId = match$1.id;
  var match$2 = GridDensityZoomProvider$Showside.use(undefined);
  var isSmallestPossibleGrid = match$2.isSmallestPossibleGrid;
  var isZoomEnabled$1 = match$2.isZoomEnabled && isZoomEnabled;
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, match$1.categories);
  var match$3 = ViewportContext$Showside.use(undefined);
  var match$4 = match$3.windowSize;
  var windowHeight = match$4.height;
  var isMobile = match$3.isMobile;
  var match$5 = LCPContext$Showside.use(undefined);
  var onMainImageRendered = match$5.onMainImageRendered;
  var match$6 = EntrypointContext$Showside.use(undefined);
  var isMiniPDPVisible = match$6.isMiniPDPVisible;
  var onOpenLink = match$6.onOpenLink;
  var onProductClick = match$6.onProductClick;
  var onAddToCart = match$6.onAddToCart;
  var match$7 = UseFirstAndLastCard$Showside.use(/* Products */1, activeCategory, layout, enableSmartCard, enableFirstCard, enableLastCard, Belt_Option.map(forcedOpenLink, function (fn) {
    return Curry._1(fn, category);
  }), category);
  var firstCard = match$7[0];
  var match$8 = RouterProvider$Showside.useRouter(undefined);
  var previewMode = match$8.previewMode;
  var sort = match$8.productSort;
  var route = match$8.route;
  var retargetingAlreadySent = React.useRef([]);
  var removeAllInfo;
  if (typeof route === "number") {
    removeAllInfo = false;
  } else {
    switch (route.TAG | 0) {
      case /* Home */0:
      case /* ListPage */1:
        removeAllInfo = isSmallestPossibleGrid;
        break;
      default:
        removeAllInfo = false;
    }
  }
  var isPDP = Belt_Option.isSome(match$8.anyProductId);
  var appliedFilters = Belt_Option.keep(match$8.productFilters, function (param) {
    return !isPDP;
  });
  var defaultFilters = Belt_Option.flatMap(Category$Showside.ExternalConnection.getStoreCategoryConnection(category), function (connection) {
    return Category$Showside.ExternalConnection.getFilterBy(connection, account);
  });
  var effectiveFilters = Facets$Showside.mergeOption(appliedFilters, defaultFilters);
  var isLive = previewMode === undefined || Caml_obj.equal(previewMode, /* PreviewLive */1);
  var photoZoomed;
  photoZoomed = typeof route === "number" || route.TAG !== /* PDP */2 ? false : Belt_Option.isSome(route._0.zoomedPhotoIndex);
  var connection = Category$Showside.ExternalConnection.getStoreCategoryConnection(category);
  var cardShape = Belt_Option.getWithDefault(forcedShape, Category$Showside.CategoryCard.getCardShape(settings.productCardShape, undefined, category.card));
  var cardSize = Belt_Option.getWithDefault(forcedSize, Category$Showside.CategoryCard.getCardSize(/* Md */4, category.card));
  var match$9 = PLPMedia$Showside.Inline.useInlineMedia(!isPDP && enableInlineMedia, category);
  var maxRequestedProductsPerPage;
  if (layout.TAG === /* SliderLayout */0) {
    maxRequestedProductsPerPage = 10;
  } else {
    var match$10 = layout._0;
    var maxRows = match$10.maxRows;
    maxRequestedProductsPerPage = maxRows !== undefined ? Math.imul(Card$Showside.Size.getColumns(match$10.columns), maxRows) : 10;
  }
  var connectedProductsSwr = usePagination(category, appliedFilters, sort, maxRequestedProductsPerPage, undefined);
  var match$11 = SWRUtils$Showside.getPageInfo(connectedProductsSwr, function (page) {
    return page.page.next;
  }, function (page) {
    return page.products;
  });
  var connectedProducts = match$11.contents;
  var isFetchingConnectedProducts = match$11.isFetching;
  var setConnectedNumPages = match$11.setSize;
  var connectedNumLoadedPages = match$11.numLoadedPages;
  var connectedNumPages = match$11.size;
  var reachedEnd = match$11.reachedEnd;
  var connectedCategorySyncStatus = Belt_Option.flatMap(Belt_Option.flatMap(connectedProductsSwr.data, function (pages) {
    return Belt_Array.get(pages, 0);
  }), function (page) {
    return page.syncStatus;
  });
  var featuredProductsList = appliedFilters !== undefined ? [] : sort !== undefined && sort >= 2 ? [] : Category$Showside.getProducts(category);
  var featuredProductsCount = featuredProductsList.length;
  var match$12 = UseApi$Showside.useProductsById(match$1.transitiveStoreId, Belt_Array.map(featuredProductsList, function (product) {
    return product.productId;
  }), settings.hideOutOfStock, true, category.id, match$6.smartnavApiHost, match$6.market, undefined);
  var isFetchingFeaturedProducts = match$12.isFetching;
  var featuredProducts = match$12.products;
  var featuredProductsCount$1 = Belt_Option.mapWithDefault(featuredProducts, featuredProductsCount, function (prim) {
    return prim.length;
  });
  var hasAppliedFilters = Belt_Option.isSome(appliedFilters);
  var hasNoResults = hasAppliedFilters && Belt_Option.mapWithDefault(connectedProducts, 0, function (prim) {
    return prim.length;
  }) === 0 && reachedEnd;
  var match$13 = usePersistentProducts(connectedProducts, isFetchingConnectedProducts, reachedEnd);
  var match$14 = usePersistentProducts(featuredProducts, isFetchingFeaturedProducts, true);
  var connectedProducts$1 = Belt_Option.getWithDefault(match$13[0], []);
  var featuredProducts$1 = Belt_Option.getWithDefault(match$14[0], []);
  var featuredPlaceholders = isFetchingFeaturedProducts ? Belt_Array.makeBy(featuredProductsCount$1, function (i) {
    return React.createElement(PlaceholderCard$Showside.make, {
      shape: cardShape,
      kind: /* Product */0,
      contentBoxStylableClassName: "product-card__content-box",
      titleStylableClassName: "category-card__title",
      key: String(i)
    });
  }) : [];
  var sliderRef = React.useRef(null);
  var match$15 = React.useState(function () {
    return false;
  });
  var setSliderInitialized = match$15[1];
  var handleSliderInit = React.useCallback(function (swiperController) {
    sliderRef.current = swiperController.el;
    Curry._1(setSliderInitialized, function (param) {
      return true;
    });
  }, [category]);
  var getViewport = function (layout) {
    var match = sliderRef.current;
    if (layout.TAG === /* SliderLayout */0 && !(match == null)) {
      return sliderRef;
    } else {
      return scrollableContainerRef;
    }
  };
  var infiniteScrollPlaceholders = match$13[1] ? [] : Belt_Option.mapWithDefault(connection, [], function (connection) {
    var placeholderLength = Caml.int_min(maxRequestedProductsPerPage, Caml.int_max(1, connection.count - Math.imul(connectedNumLoadedPages, maxRequestedProductsPerPage) | 0));
    var placeholderLength$1 = Caml_obj.equal(connectedProducts$1, []) && connectedProductsSwr.error === undefined || placeholderLength < 1 ? placeholderLength : 1;
    return Belt_Array.makeBy(placeholderLength$1, function (i) {
      var makePlaceholder = function (dataTestId, children, param) {
        var tmp = {
          showTitle: !removeAllInfo,
          shape: cardShape,
          kind: /* Product */0,
          contentBoxStylableClassName: "product-card__content-box",
          titleStylableClassName: "category-card__title",
          key: "infinite-" + String(i) + ""
        };
        if (dataTestId !== undefined) {
          tmp.dataTestId = Caml_option.valFromOption(dataTestId);
        }
        if (children !== undefined) {
          tmp.children = Caml_option.valFromOption(children);
        }
        return React.createElement(PlaceholderCard$Showside.make, tmp);
      };
      if (i !== 0) {
        return makePlaceholder("placeholder-card-testid", undefined, undefined);
      }
      var tmp = {
        numLoadedPages: connectedNumLoadedPages,
        numPages: connectedNumPages,
        setNumPages: setConnectedNumPages,
        viewport: getViewport(layout),
        renderChildren: function (el) {
          return makePlaceholder("proximity-card-testid", Caml_option.some(el), undefined);
        },
        increaseOffsetForMobile: isMobile,
        key: "proximity-sensor"
      };
      if (connectedProductsSwr.error !== undefined) {
        tmp.error = connectedProductsSwr.error;
      }
      return React.createElement(InfiniteScrollProximitySensor$Showside.make, tmp);
    });
  });
  var match$16 = category.expandVariantsInProductsListing;
  var match$17 = settings.expandVariantsInProductsListing;
  var match$18 = Belt_Option.map(account, function (account) {
    return account.expandVariantsInProductsListing;
  });
  var expandVariantsInProductsListing = match$16 !== undefined ? match$16 : match$17 !== undefined ? match$17 : match$18 !== undefined ? match$18 : false;
  var removeDuplicateProducts = function (listA, listB) {
    return Belt_Array.keepMap(listA, function (param) {
      var product = param[1];
      if (Belt_Array.some(listB, function (param) {
        return param[1].id === product.id;
      })) {
        return;
      } else {
        return [undefined, product];
      }
    });
  };
  var products = React.useMemo(function () {
    var featuredProducts$2 = Product$Showside.zipTaggedProducts(Belt_Array.map(featuredProducts$1, function (product) {
      return Product$Showside.keepVariants(product, function (variant) {
        return Product$Showside.Variant.matchesFilter(variant, variant.options, effectiveFilters);
      });
    }), featuredProductsList);
    var connectedProducts$2 = Belt_Array.map(Belt_Array.map(connectedProducts$1, function (product) {
      return Product$Showside.keepVariants(product, function (variant) {
        return Product$Showside.Variant.matchesFilter(variant, variant.options, effectiveFilters);
      });
    }), function (product) {
      return [undefined, product];
    });
    var connectedProducts$3 = featuredProductsCount$1 <= 30 ? removeDuplicateProducts(connectedProducts$2, featuredProducts$2) : connectedProducts$2;
    var products = Belt_Array.concatMany([featuredProducts$2, connectedProducts$3]);
    if (expandVariantsInProductsListing) {
      return Product$Showside.expandVariantsByOptionNames(settings.hideOutOfStock, appliedFilters, products, ["Color"]);
    } else {
      return products;
    }
  }, [Belt_Array.map(connectedProducts$1, function (product) {
    return Product$Showside.getKey(undefined, product);
  }).join(""), Belt_Array.map(featuredProducts$1, function (product) {
    return Product$Showside.getKey(undefined, product);
  }).join(""), Belt_Array.map(featuredProductsList, function (tag) {
    return Belt_Option.getWithDefault(tag.variantId, tag.productId);
  }).join(""), expandVariantsInProductsListing, sort, effectiveFilters]);
  var numOfProductsBeforeFiltering = products.length;
  var isConnectedAndHasProducts = Belt_Option.mapWithDefault(connection, false, function (connection) {
    return connection.count > 0;
  });
  var isExpectedToRenderProducts = !hasAppliedFilters && isConnectedAndHasProducts && numOfProductsBeforeFiltering === 0;
  var rootMarginX = Math.imul(match$4.width, isMobile ? 3 : 2);
  var slidesPerView = Math.ceil(Category$Showside.CardSize.getSlidesPerView(cardSize)) | 0;
  var slidesPerView$1 = priority !== 1 ? priority !== 2 ? undefined : slidesPerView : slidesPerView << 1;
  React.useEffect(function () {
    var productsNotSentYet = Belt_Array.keep(Belt_Array.map(products, function (param) {
      return param[1];
    }), function (product) {
      return Belt_Array.some(retargetingAlreadySent.current, function (id) {
        return id === product.id;
      }) === false;
    });
    if (productsNotSentYet.length !== 0) {
      UseTracking$Showside.trackRetargeting(account, configId, category, undefined, undefined, isMobile, undefined, retargetingAlreadySent.current.length, undefined, productsNotSentYet, undefined, "view_item_list");
      retargetingAlreadySent.current = Belt_Array.concat(retargetingAlreadySent.current, Belt_Array.map(productsNotSentYet, function (p) {
        return p.id;
      }));
    }
  }, [Belt_Array.joinWith(products, "|", function (param) {
    return Product$Showside.getKey(undefined, param[1]);
  })]);
  var cards = React.useMemo(function () {
    var cards = Belt_Array.concatMany([featuredPlaceholders, Belt_Array.mapWithIndex(products, function (index, param) {
      var product = param[1];
      var tag = param[0];
      var tagId = Belt_Option.mapWithDefault(tag, "", function (tag) {
        return tag.id;
      });
      var tagVariantId = Belt_Option.flatMap(tag, function (tag) {
        return tag.variantId;
      });
      var key = Product$Showside.getKey(undefined, product) + tagId + Belt_Option.getWithDefault(tagVariantId, String(index)) + category.id;
      var fallbackElement = React.createElement(PlaceholderCard$Showside.make, {
        showTitle: !removeAllInfo,
        shape: cardShape,
        kind: /* Product */0,
        contentBoxStylableClassName: "product-card__content-box",
        titleStylableClassName: "category-card__title",
        key: key
      });
      if (photoZoomed) {
        return fallbackElement;
      }
      var tmp = {
        shape: cardShape,
        productCategory: category,
        product: product,
        onClick: onProductClick,
        onAddToCart: onAddToCart,
        onImageRendered: onMainImageRendered,
        removeAllInfo: removeAllInfo,
        onOpenLink: onOpenLink,
        dataCount: index
      };
      if (tagVariantId !== undefined) {
        tmp.activeVariantId = tagVariantId;
      }
      if (isMiniPDPVisible !== undefined) {
        tmp.isMiniPDPVisible = Caml_option.valFromOption(isMiniPDPVisible);
      }
      return React.createElement(LazyRender$Showside.make, {
        trackRenderedElementsWithId: product.id,
        thresholds: [0.1],
        rootMargin: "" + String(windowHeight) + "px " + String(rootMarginX) + "px",
        viewport: getViewport(layout),
        children: React.createElement(ProductCard$Showside.make, tmp),
        fallbackElement: fallbackElement,
        key: key
      });
    }), infiniteScrollPlaceholders]);
    if (slidesPerView$1 !== undefined) {
      return Belt_Array.slice(cards, 0, slidesPerView$1);
    } else {
      return cards;
    }
  }, [connectedNumLoadedPages, Belt_Array.map(Belt_Array.map(products, function (param) {
    return param[1];
  }), function (product) {
    return Product$Showside.getKey(undefined, product);
  }).join(","), featuredPlaceholders.length, infiniteScrollPlaceholders.length, photoZoomed, cardShape, rootMarginX, windowHeight, onProductClick, onAddToCart, onMainImageRendered, slidesPerView$1, match$15[0], BasicTypes$Showside.layoutToString(layout), removeAllInfo]);
  var className = isFetchingConnectedProducts && Caml_obj.notequal(connectedProducts$1, []) || isFetchingFeaturedProducts && Caml_obj.notequal(featuredProducts$1, []) ? CSS$Showside.prefix("opacity-50 pointer-events-none") : "";
  if (cards.length === 0 && isExpectedToRenderProducts) {
    var displayMessage = connectedCategorySyncStatus !== undefined && connectedCategorySyncStatus.isComplete ? "No products in the connected category." : "Hang tight, product are still being generated for this category.";
    var devMessage = "No products were rendered.";
    var storeCategoryId = Belt_Option.mapWithDefault(Category$Showside.ExternalConnection.getStoreCategoryConnection(category), "null", function (connection) {
      return "\"" + connection.categoryId + "\"";
    });
    return React.createElement(ErrorReporter$Showside.make, {
      error: RollbarInstance$Showside.makeError(isLive, devMessage),
      displayMessage: displayMessage,
      extraInfo: {
        devMessage: devMessage,
        categoryId: category.id,
        configId: configId,
        storeCategoryId: storeCategoryId
      },
      reportEvery: 1000
    });
  }
  if (layout.TAG === /* SliderLayout */0) {
    var match$19 = layout._0;
    var tmp = {
      id: category.id,
      rows: match$19.rows,
      children: cards,
      shouldCenter: shouldCenterSlides,
      slidesPerView: match$19.slidesPerView,
      gap: match$19.gap,
      effect: match$19.effect,
      nav: match$19.nav,
      transition: match$19.transition,
      transitionSpeed: match$19.transitionSpeed,
      autoplay: match$19.autoplay,
      autoplayDelay: match$19.autoplayDelay,
      loop: match$19.loop,
      onInit: handleSliderInit,
      className: className
    };
    if (match$19.padding !== undefined) {
      tmp.padding = match$19.padding;
    }
    if (match$19.maxWidth !== undefined) {
      tmp.maxWidth = match$19.maxWidth;
    }
    if (firstCard !== undefined) {
      tmp.firstSlide = Caml_option.valFromOption(firstCard);
    }
    return React.createElement(ListPageSlider$Showside.make, tmp);
  }
  var match$20 = layout._0;
  if (hasNoResults) {
    return React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["text-xl text-primary", isMobile ? "px-4" : "px-8"]))
    }, "No results for selected filters.");
  }
  var tmp$1 = {
    columns: isZoomEnabled$1 ? match$2.gridColumns : match$20.columns,
    children: cards,
    gap: match$20.gap,
    className: className
  };
  if (match$20.maxRows !== undefined) {
    tmp$1.maxRows = match$20.maxRows;
  }
  if (match$20.maxWidth !== undefined) {
    tmp$1.maxWidth = match$20.maxWidth;
  }
  var tmp$2 = isPaddingEnabled ? match$20.padding : 0;
  if (tmp$2 !== undefined) {
    tmp$1.paddingOverride = tmp$2;
  }
  if (firstCard !== undefined) {
    tmp$1.firstChild = Caml_option.valFromOption(firstCard);
  }
  var tmp$3 = match$7[1];
  if (tmp$3 !== undefined) {
    tmp$1.lastChild = Caml_option.valFromOption(tmp$3);
  }
  var tmp$4 = {
    slotAllowOverflow: match$9.slotAllowOverflow,
    children: React.createElement(ListPageGrid$Showside.make, tmp$1)
  };
  if (match$9.renderSlots !== undefined) {
    tmp$4.renderSlots = Caml_option.valFromOption(match$9.renderSlots);
  }
  if (match$9.slotCardWidth !== undefined) {
    tmp$4.slotCardWidth = Caml_option.valFromOption(match$9.slotCardWidth);
  }
  if (match$9.slotCardHeight !== undefined) {
    tmp$4.slotCardHeight = Caml_option.valFromOption(match$9.slotCardHeight);
  }
  if (match$9.slotCardOffset !== undefined) {
    tmp$4.slotCardOffset = Caml_option.valFromOption(match$9.slotCardOffset);
  }
  return React.createElement(ListPageGridCustomSlots$Showside.make, tmp$4);
}
ProductsContent.displayName = "ProductsContent";
var make = React.memo(ProductsContent);
export { usePersistentProducts, usePagination, make };
/* make Not a pure module */